import { GatsbyImage } from "gatsby-plugin-image"
import React, { useEffect, useRef, useState } from "react"

import { Link } from "gatsby"
import doenerCase from "scripts/doenerCase"

export const OtherAuthors = ({ ressort, other_authors }) => {
  const [authorsDropdown, setAuthorsDropdown] = useState(false)
  const otherAuthorsToggleRef = useRef(null)
  const toggle_authors_dropdown = () => {
    setAuthorsDropdown(!authorsDropdown)
  }

  const close_authors_dropdown = (e) => {
    if (!e.target?.id || !e.target?.id.startsWith("other_authors_toggle")) {
      setAuthorsDropdown(false)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", close_authors_dropdown)
    document.body.addEventListener("click", close_authors_dropdown)
    return () => {
      window.removeEventListener("scroll", close_authors_dropdown)
      document.body.removeEventListener("click", close_authors_dropdown)
    }
  }, [])

  return (
    <React.Fragment>
      <div
        className="level-item"
        aria-haspopup="true"
        onClick={toggle_authors_dropdown}
        onKeyDown={() => {}}
        role="button"
        tabIndex={-1}
        style={{ position: "relative", minWidth: 42, height: 32 }}
      >
        {other_authors
          .slice(0, 3)
          .map((_, index) =>
            !index ? (
              <div
                ref={otherAuthorsToggleRef}
                key={"authors-" + index}
                className={`has-background-${ressort} has-text-weight-bold has-text-white is-clickable`}
                style={{
                  position: "absolute",
                  left: `${index * 5}px`,
                  display: "flex",
                  height: 32,
                  width: 32,
                  borderRadius: "100%",
                  color: "white",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid white",
                }}
                id={`other_authors_toggle-${index}`}
              >
                <div id={`other_authors_toggle-plus`}>
                  + {other_authors.length}
                </div>
              </div>
            ) : (
              <div
                id={`other_authors_toggle-${index}`}
                key={"authors-" + index}
                className={`has-background-${ressort} has-text-weight-bold has-text-white is-clickable`}
                style={{
                  position: "absolute",
                  left: `${index * 5}px`,
                  display: "flex",
                  height: 32,
                  width: 32,
                  borderRadius: "100%",
                  color: "white",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid white",
                }}
              ></div>
            )
          )

          .reverse()}
      </div>

      <div
        className={`box ${authorsDropdown ? "" : "is-hidden"}`}
        style={{
          position: "fixed",
          left:
            otherAuthorsToggleRef?.current?.getBoundingClientRect()?.left -
              42 || 150,
          top:
            otherAuthorsToggleRef?.current?.getBoundingClientRect()?.top + 42 ||
            150,
          width: "max-content",
          zIndex: 10,
        }}
      >
        {other_authors.map((author, index) => {
          const authorNameDoenerCase = doenerCase(author.name)
          if (!!author.strapi_data) {
            return (
              <div
                key={"moreauthors" + index}
                className="other-authors-list-item"
                style={{
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <Link to={`/ueber-uns/redaktion/${authorNameDoenerCase}`}>
                  <GatsbyImage
                    image={
                      author.strapi_data.image.localFile.childImageSharp
                        .thumbnail
                    }
                    style={{ width: 32, height: 32, zIndex: 10 }}
                    imgStyle={{ borderRadius: "100%" }}
                    alt={author.name}
                    title={author.name}
                    className="author-portrait mx-1"
                  />
                </Link>
                <Link
                  className="link"
                  to={`/ueber-uns/redaktion/${authorNameDoenerCase}`}
                >
                  {author.name}
                </Link>
              </div>
            )
          }
          return (
            <div
              key={"moreauthors" + index}
              className="other-authors-list-item"
              style={{
                alignItems: "center",
                display: "flex",
              }}
            >
              <div
                className={`has-background-${ressort} has-text-weight-bold mx-1`}
                style={{
                  display: "flex",
                  height: 32,
                  width: 32,
                  borderRadius: "100%",
                  color: "white",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid white",
                }}
              >
                {author.name.charAt(0)}
              </div>
              {author.name}
            </div>
          )
        })}
      </div>
    </React.Fragment>
  )
}
